import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { FC } from 'react'

type Props = {
  open: boolean
  name: string
  handleClose: (execute?: boolean) => void
}

export const DeleteDialog: FC<Props> = ({ open, name, handleClose }) => {
  return (
    <Dialog
      open={open}
      onClose={() => handleClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Delete User "{name}"</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">Are You Sure?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)}>Cancel</Button>
        <Button onClick={() => handleClose(true)} autoFocus color="error" variant="contained">
          Delete User
        </Button>
      </DialogActions>
    </Dialog>
  )
}
